<div class="table-style" *ngIf="functionalAreasTable.data.length > 0 && !isLoading">
    <table mat-table [dataSource]="functionalAreasTable" multiTemplateDataRows matSort >

        <ng-container matColumnDef="area">
            <th mat-header-cell *matHeaderCellDef><span translate>PRODUCTS.FUNCAREA</span></th>
            <td mat-cell *matCellDef="let element" style="width: 95%;" class="course-title-cell">
                <h3>{{element}}</h3>
            </td>
        </ng-container>

        <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element" class="expand-cell">
              <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
              </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td class="td-detail" mat-cell *matCellDef="let row" [attr.colspan]="this.displayedColumns.length">
                <div class="element-detail" [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="detail-content">
                        <div class="white-box">
                            <div class="text-left w-100">
                                <table mat-table [dataSource]="functionalAreasImprovementsTables.get(row)" multiTemplateDataRows matSort class="table-style">
                                    <ng-container matColumnDef="nr">
                                        <th mat-header-cell *matHeaderCellDef><span translate>PRODUCTS.NUMBER</span></th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.ProjImprID }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="description">
                                        <th mat-header-cell *matHeaderCellDef><span translate>PRODUCTS.NAME</span></th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element[localizedFields.get('Description')] }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="country">
                                        <th mat-header-cell *matHeaderCellDef><span translate>PRODUCTS.COUNTRY</span></th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ getCountriesString(element.Countries) }}
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedImprovementColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedImprovementColumns;" class="element-row cp" (click)="openImprovement(row)"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row" [class.expanded-row]="expandedElement === row" (click)="setParameters(row)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
</div>

<div class="message-box warning" *ngIf="functionalAreasTable.data.length == 0 && !isLoading">
  <mat-label translate>COMMONS.NO_ELEMENTFOUND</mat-label>
</div>

<div class="button-container" *ngIf="functionalAreasTable.data.length > 0">
    <button mat-flat-button color="primary" (click)="getPdf()">
        <span translate>PRODUCTS.EXPORT</span>
    </button>
</div>

<div *ngIf="isLoading">
    <tb-loading></tb-loading>
</div>
